export enum InventoryEffect {
    NotRealized = 100,
    Deferred = 200,
    Realized = 300
}
